module.exports = __webpack_public_path__ + "static/img/instagram03.49d7780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social/instagram03.png
// module id = M/vl
// module chunks = 0